import {request} from '../../lib/api.js'
import {MAX_COHORT, validId, validHash, requireValue} from './cohortContract.js'
const base = '/api/artwork/cohorts'
const transport = options => ({...options, credentials: 'omit', cache: 'no-store', redirect: 'error', audit: {redact: true, action: 'native-cohort-owner-action'}})
const write = (path, body, signal) => request(path, transport({method: 'POST', body, signal, headers: {'X-SR-Cohort-Intent': 'explicit-owner-action'}}))
// Origin is supplied by the browser itself. Never forge it or send credentials
// in query strings, cookies, UI state or persistent recovery records.
export const cohortApi = {
  connections: ({signal} = {}) => request(base + '/connections', transport({signal})),
  propose({parentGrantId, jobIds, expiresAt}, {signal} = {}) {
    requireValue(validId(parentGrantId) && Array.isArray(jobIds) && jobIds.length > 0 && jobIds.length <= MAX_COHORT && jobIds.every(validId) && new Set(jobIds).size === jobIds.length && Number.isSafeInteger(expiresAt))
    return write(base + '/proposals', {parentGrantId, jobIds: [...jobIds], expiresAt}, signal)
  },
  consent({challengeId, expectedDigest}, {signal} = {}) {
    requireValue(validId(challengeId) && validHash(expectedDigest))
    return write(base + '/consent', {challengeId, expectedDigest}, signal)
  },
  receipt(challengeId, {signal} = {}) {
    requireValue(validId(challengeId))
    return request(base + '/consent/' + encodeURIComponent(challengeId), transport({signal}))
  },
  progress(cohortId, {signal} = {}) {
    requireValue(validId(cohortId))
    return request(base + '/' + encodeURIComponent(cohortId), transport({signal}))
  },
  revoke(cohortId, {signal} = {}) {
    requireValue(validId(cohortId))
    return write(base + '/' + encodeURIComponent(cohortId) + '/revoke', {}, signal)
  },
}
